/**
 * Build-time feature switches for parked features: the code stays in the repo, but nothing in the
 * UI (sidebar, Home, page search, routes, Admin) exposes it while the flag is false.
 *
 * aiChat: the full-screen Foundry *agent* chat at /ai (src/pages/ai, server/agent.ts). Parked on
 * 2026-10-20: the Foundry agent didn't run MCP tool calls reliably, even in Foundry's own
 * playground. The PSA assistants (direct model + server-built context) are unaffected. The server
 * half is gated separately by AGENT_CHAT_FEATURE in server/agent.ts; flip both to bring it back.
 */
export const FEATURES = {
  aiChat: false,
} as const;
